<div class="layout-container">
  <header></header>
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
  <div
    [ngStyle]="{
      'background-image': 'url(/assets/img/patterns/pattern-' + theme + '.svg)',
    }"
    class="pattern"
  ></div>
  <footer></footer>
</div>
